<template>
  <el-tabs type="border-card" v-model="tabName">
    <el-tab-pane name="workform">
      <template #label>
        <span> 单据信息 </span>
      </template>
      <div style="width: calc( 100% - 10px ); margin:0 auto;padding:5px;">
        <h4 class="form-title">工厂回货单</h4>
        <el-form :model="forms" ref="forms">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="所属公司" label-width="100px">
                <el-tree-select ref="companys" v-model="forms.companyId" :data="companys" check-strictly
                  @change="companyChange();" :render-after-expand="false" :disabled="bounds.length > 0" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
              <el-form-item label="回货部门" label-width="100px">
                <el-select v-model="forms.departments" multiple collapse-tags-tooltip style="width: 100%" placeholder=""
                  filterable disabled>
                  <el-option v-for="dd in departments" :key="dd.departmentName" :label="dd.departmentName"
                    :value="dd.id" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="!id">
              <el-form-item label="关联入库单号" prop="">
                <el-input v-model="forms.inBillCode" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="入库单号" label-width="100px">
                <el-input v-model="forms.inBillCode" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="入库金额" label-width="100px">
                <el-input v-model="forms.payBillAmount" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="操作类型" label-width="100px">
                <el-select v-model="forms.billType" placeholder="操作类型" disabled>
                  <el-option v-for="item in dict.billTypes" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="单据编号" label-width="100px">
                <el-input v-model="forms.billCode" placeholder="单据编号" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="单据时间" label-width="100px">
                <el-input v-model="forms.billDate" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="操作人员" label-width="100px">
                <el-input v-model="forms.userName" disabled style="width:150px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <!-- 根据明细来，如果回货之后扣减工厂库存，库存不够出现欠工厂，才需要填写金单价 -->
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="当日金单价" label-width="100px">
                <el-input-number v-model="forms.unitPrice" :min="0" :max="10000000" placeholder="当日金单价"
                  v-if="unitPriceVisible" :disabled="!!id"></el-input-number>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="金料材质" label-width="100px">
                <el-select v-model="forms.materialCode" placeholder="请选择">
                  <el-option v-for="item in dict.metals" :key="item.id" :label="item.name + '（' + item.value + '）'"
                    :value="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="回货总金重" label-width="100px">
                <el-input-number v-model="forms.totalNumber" :min="0" :max="10000000" disabled
                  placeholder="0.00"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item label="操作备注" label-width="100px">
                <el-input v-model="forms.reason" style="width: 90%;" :disabled="!!id"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="18" :xl="18" style="text-align: left;">
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" style="text-align: right; margin-bottom: 10px;">
              <el-button @click="$router.go(-1)">返回</el-button>

              <el-button type="info" @click="openEvent()" v-if="!id">导入回货成品</el-button>
              <el-button type="primary" v-if="!id && bounds.length > 0" @click="saveEvent()">保存单据</el-button>

              <el-button type="primary" @click="fundEvent()" v-if="forms.status == 1">财务确认</el-button>
            </el-col>
          </el-row>
        </el-form>

        <el-tabs type="border-card" v-model="formName">
          <el-tab-pane name="boundform">
            <template #label>
              <span> 回货成品 </span>
            </template>

            <el-table :data="bounds" border stripe size="small" style="margin: 15px auto; width: 100%;">
              <el-table-column type="index" align="center" label="序号" width="45"> </el-table-column>
              <el-table-column prop="departmentName" label="部门名称" width="110" show-overflow-tooltip>
                <template #default="scope">
                  <el-select v-model="scope.row.departmentId" placeholder="部门名称" filterable size="small"
                    :disabled="!!id">
                    <el-option v-for="item in departments" :key="item.departmentName" :label="item.departmentName"
                      :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="factoryName" label="工厂名称" width="130">
                <template #default="scope">
                  <el-select v-model="scope.row.factoryName" placeholder="工厂名称" filterable size="small"
                    :disabled="!!id">
                    <el-option v-for="item in dict.factorys" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="brandModelCode" label="品牌款号" width="90" show-overflow-tooltip></el-table-column>
              <el-table-column prop="serialCode" label="批次号" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column prop="detailName" label="名称" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column prop="stockNumber" label="件数" width="55" show-overflow-tooltip></el-table-column>
              <el-table-column prop="goldWeight" label="净金重" width="65" show-overflow-tooltip></el-table-column>
              <el-table-column prop="laborUnitPrice" label="工费（元/克）" width="95" show-overflow-tooltip></el-table-column>

              <el-table-column prop="stoneNumber" label="镶嵌数量" width="65" show-overflow-tooltip></el-table-column>
              <el-table-column prop="stoneCarat" label="重量（克拉）" width="90" show-overflow-tooltip></el-table-column>
              <el-table-column prop="stoneUnitPrice" label="镶嵌物单价" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column prop="stoneBasicPrice" label="镶嵌物金额" width="100" show-overflow-tooltip></el-table-column>

              <el-table-column prop="inlayUnitPrice" label="镶嵌工费单价" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column prop="inlayLaborPrice" label="镶工费" width="60" show-overflow-tooltip></el-table-column>

              <el-table-column prop="laborUnitPrice" label="基本工费" width="80" show-overflow-tooltip></el-table-column>
              <el-table-column prop="certificatePrice" label="证书费" width="60" show-overflow-tooltip></el-table-column>
              <el-table-column prop="additionalPrice" label="附加费" width="60" show-overflow-tooltip></el-table-column>
              <el-table-column prop="processingPrice" label="应付供应商费用" width="105"
                show-overflow-tooltip></el-table-column>
              <el-table-column prop="useBrandPrice" label="品牌使用费" width="80" show-overflow-tooltip></el-table-column>
              <el-table-column prop="taggingPrice" label="挂签费" width="60" show-overflow-tooltip></el-table-column>
              <el-table-column prop="otherPrice" label="其他费" width="60" show-overflow-tooltip></el-table-column>

              <el-table-column label="操作" width="100" fixed="right">
                <template #default="item">
                  <el-link @click="bounds.splice(bounds.indexOf(item.row), 1)" type="primary" size="small"
                    style="margin:5px;">删除</el-link>
                </template>
              </el-table-column>
            </el-table>

          </el-tab-pane>

          <el-tab-pane name="materialform">
            <template #label>
              <span> 金料记录 </span>
            </template>

            <el-table :data="materials" border stripe size="small" style="margin: 15px auto; width: 100%;">
              <el-table-column type="index" align="center" label="序号" width="45"> </el-table-column>
              <el-table-column prop="billType" label="单据类型" width="100" show-overflow-tooltip> </el-table-column>
              <!-- <el-table-column prop="memo" label="摘要" width="100" show-overflow-tooltip> </el-table-column> -->
              <el-table-column prop="materialCode" label="材质编号" width="80" show-overflow-tooltip> </el-table-column>
              <el-table-column prop="materialName" label="材质名称" width="80" show-overflow-tooltip> </el-table-column>
              <el-table-column prop="factoryName" label="工厂名称">
                <template #default="scope">
                  <el-select v-model="scope.row.factoryName" placeholder="送料工厂" filterable @change="materialChange()"
                    :disabled="!!id">
                    <el-option v-for="item in dict.factorys" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="departmentName" label="渠道" width="90" show-overflow-tooltip> </el-table-column>
              <el-table-column prop="unitPrice" label="本次单价" width="90"> </el-table-column>
              <el-table-column prop="stockNumber" label="操作克重/数量" width="180">
                <template #default="scope">
                  <el-input-number v-model="scope.row.stockNumber" :min="-100000" :max="10000000"
                    @change="materialChange()" placeholder="0.00" :disabled="!!id"> </el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="stockPrice" label="总价" width="100"> </el-table-column>

              <el-table-column prop="remainNumber" label="结余数" width="110">
                <template #header>
                  <p v-if="!id">操作前结余数</p>
                  <p v-if="id">操作后结余数</p>
                </template>
              </el-table-column>
              <el-table-column prop="remainPrice" label="结余价" width="110">
                <template #header>
                  <p v-if="!id">操作前结余价</p>
                  <p v-if="id">操作后结余价</p>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注" width="280" show-overflow-tooltip> </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>

      </div>
    </el-tab-pane>
  </el-tabs>

  <static-dialog ref="uploadDialog" class="dialog" title="上传工厂回货">
    <div class="load-dialog" style="text-align:center; max-width:500px;margin:0px auto;">
      <el-upload ref="upload" action="#" drag:limit="1" :auto-upload="false" :on-change="uploadEvent">
        <div style="display: block; font-size: 1.5em;">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div style="display: block; margin-top: 20px;">
        <a :href="apiUrl + '/static/template/fund-stockin.xlsx'" target="_blank">下载回货单模板</a>
      </div>
    </div>
  </static-dialog>
</template>
<script>
import StaticDialog from "@/components/static-dialog.vue";
//import { resolveTable } from "@/api/subupload";

export default {
  name: "StockMaterialDetail",
  components: { StaticDialog },
  data() {
    return {
      tabName: "workform",
      formName: "boundform",
      companys: [],
      departments: [],
      id: '',
      dict: {
        factorys: [],
        billTypes: [],
      },

      forms: { "billType": "工厂回货", "materialCode": "Y999", "unitPrice": 0 },
      unitPriceVisible: false,

      materials: [],
      bounds: [],
      columns: [
        { 'prop': 'departmentName', 'label': '部门名称' },
        { 'prop': 'factoryName', 'label': '工厂名称' },
        { 'prop': 'brandModelCode', 'label': '品牌款号' },
        { 'prop': 'serialCode', 'label': '批次号' },
        { 'prop': 'detailName', 'label': '名称' },
        { 'prop': 'stockNumber', 'label': '件数' },
        { 'prop': 'goldWeight', 'label': '净金重' },
        { 'prop': 'laborUnitPrice', 'label': '工费（元/克）' },
        { 'prop': 'stoneNumber', 'label': '镶嵌数量' },
        { 'prop': 'stoneCarat', 'label': '重量（克拉）' },
        { 'prop': 'stoneUnitPrice', 'label': '镶嵌物单价' },
        { 'prop': 'stoneBasicPrice', 'label': '镶嵌物金额' },
        { 'prop': 'inlayUnitPrice', 'label': '镶嵌工费单价' },

        //{ 'prop': 'laborUnitPrice', 'label': '基本工费' },
        { 'prop': 'inlayLaborPrice', 'label': '镶工费' },
        { 'prop': 'certificatePrice', 'label': '证书费' },
        { 'prop': 'additionalPrice', 'label': '附加费' },
        { 'prop': 'processingPrice', 'label': '应付供应商费用' },

        { 'prop': 'useBrandPrice', 'label': '品牌使用费' },
        { 'prop': 'taggingPrice', 'label': '挂签费' },
        { 'prop': 'otherPrice', 'label': '其他费' },
      ],
    };
  },
  methods: {
    openEvent() {
      if ((this.forms.companyId || '').length == 0) {
        this.$message.error('请先选择所属公司');
        return;
      }
      this.$refs.uploadDialog.toggle();
    },
    billTypeChange() {
      let that = this;
      console.log(this.dict.billTypes);
      let items = this.dict.billTypes.filter(function (item) {
        return item.value == that.forms.billType;
      });
      this.$kaung.fetch({ url: 'StockMaterialBill/GetBillCode?BillType=' + items[0].value + '&Prev=' + items[0].attribute, method: 'get' })
        .then((res) => {
          that.forms.billCode = 'H-' + res.data + '-' + that.bounds.length;
          that.forms.billDate = that.$util.fmtDate(new Date());
          that.forms.userName = that.$store.getters.getUserInfo.userName;
        });
    },
    uploadEvent(file) {
      this.$refs.upload.clearFiles();
      // resolveTable(file).then((res) => {
      //   console.log(res);
      //   if (res.code === 200) {
      //     this.$message({ message: "上传成功", type: "success", });
      //     this.$refs.uploadDialog.toggle();
      //     this.matchTable(res.data);
      //   }
      // });

      var formData = new FormData();
      formData.append(file.name, file.raw);
      formData.append("fileType", 'excel');
      formData.append("dataType", this.$options.name);
      formData.append("columns", JSON.stringify(this.columns));

      this.$kaung.transfer(formData)
        .then((res) => {
          this.$message({ message: res.content, type: res.type });
          if (res.code === 200) {
            this.bounds = res.data.filter(q => !!q.brandModelCode && !!q.goldWeight);

            let goldWeight = 0.00;
            let processingPrice = 0.00;
            this.bounds.forEach(item => {
              item.departmentId = this.departments.filter(q => q.departmentName == item.departmentName)[0].id;

              let factory = this.dict.factorys.filter(q => (q.name == item.factoryName) || (q.value == item.factoryName))[0];
              item.factoryCode = factory.name;
              item.factoryName = factory.value;

              item.additionalPrice = parseFloat(item.additionalPrice || '0').toFixed(2);
              item.certificatePrice = parseFloat(item.certificatePrice || '0').toFixed(2);
              item.goldWeight = parseFloat(item.goldWeight || '0').toFixed(4);
              item.laborUnitPrice = parseFloat(item.laborUnitPrice || '0').toFixed(2);
              item.otherPrice = parseFloat(item.otherPrice || '0').toFixed(2);
              item.processingPrice = parseFloat(item.processingPrice || '0').toFixed(2);
              item.stockNumber = parseFloat(item.stockNumber || '0').toFixed(2);

              item.stoneCarat = parseFloat(item.stoneCarat || '0').toFixed(4);
              item.inlayLaborPrice = parseFloat(item.inlayLaborPrice || '0').toFixed(2);
              item.inlayUnitPrice = parseFloat(item.inlayUnitPrice || '0').toFixed(2);
              item.stoneNumber = parseFloat(item.stoneNumber || '0').toFixed(2);
              item.stoneUnitPrice = parseFloat(item.stoneUnitPrice || '0').toFixed(2);
              item.stoneBasicPrice = parseFloat(item.stoneBasicPrice || '0').toFixed(2);
              item.taggingPrice = parseFloat(item.taggingPrice || '0').toFixed(2);
              item.useBrandPrice = parseFloat(item.useBrandPrice || '0').toFixed(2);

              goldWeight += parseFloat(item.goldWeight);
              processingPrice += parseFloat(item.processingPrice);
            });
            this.forms.totalNumber = goldWeight;
            this.forms.payBillAmount = processingPrice;

            this.billTypeChange();
            this.$refs.uploadDialog.toggle();
          }
        });
    },

    companyChange() {
      this.forms.departments = null;
      this.departments = [];
      var that = this;
      this.$kaung.departments(this.forms.companyId).then((res) => {
        that.departments = res;
      });
    },
    saveEvent() {
      if ((this.forms.billType || '').length == 0) {
        this.$message.error('请选择操作类型');
        return;
      }

      let metal = this.forms.materialCode ? this.dict.metals.filter(item => item.name == this.forms.materialCode)[0] : {};
      this.forms.materialName = metal.value;

      // let factory = this.forms.factoryCode ? this.dict.factorys.filter(item => item.value == this.forms.factoryCode)[0] : {};
      // this.forms.factoryName = factory.value;

      let valider = true;
      this.bounds.forEach(item => {
        if ((item.brandModelCode || '') <= '' || (item.serialCode || '') <= '') {
          valider = false;
          this.$message.error('请填写明细的款号及批次号');
          return;
        }
        item.materialCode = this.forms.materialCode;
        item.materialName = this.forms.materialName;

        if ((item.departmentId || '').length == 0 || (item.factoryName || '').length == 0) {
          valider = false;
          this.$message.error('请选择明细所属的部门及工厂信息');
          return;
        }
        let factory = this.dict.factorys.filter(q => q.value == item.factoryName)[0];
        item.factoryCode = factory.name;

        item.departmentName = this.departments.filter(q => q.id == item.departmentId)[0].departmentName;
      });
      if (!valider) return;

      // if ((this.forms.unitPrice || 0) <= 0) {
      //   this.$message.error('请填写当日金单价');
      //   return;
      // }

      let that = this;
      this.$refs.forms.validate((valid) => {
        if (!valid) return;

        let dtos = {
          bill: this.forms,
          bounds: this.bounds,
        };
        this.$kaung.fetch({
          url: 'StockMaterialBill/SaveBound',
          method: 'post',
          data: dtos
        })
          .then((res) => {
            console.log(res);
            that.$message({ type: res.type, message: res.content });
            if (res.code == 900) {
              that.unitPriceVisible = true;
            }
            else if (res.code == 200) {
              that.forms = res.data.bill;
              that.bounds = res.data.bounds;

              that.$router.push({ path: "index", query: { id: that.forms.id } });
            }
          });
      });
    },
    
    fundEvent() {
      this.$confirm("确认以上单据信息无误，点击保存并归档？", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", })
        .then(() => {
          let that = this;
          this.$kaung.fetch({
            url: 'StockMaterialBill/FundForm?id=' + this.forms.id,
            method: 'post'
          })
            .then((res) => {
              that.$message({ type: res.type, message: res.content });
              if (res.code == 200) {
                that.forms = res.data;
              }
            });
        });
    },
  },
  mounted() {
    this.id = this.$route.query.id || '';

    if (this.id) {
      this.unitPriceVisible = true;
      this.$kaung.fetch({ url: 'StockMaterialBill/GetBillDto?id=' + this.id, method: 'get' })
        .then((res) => {
          this.forms = res.data.bill;
          this.id = this.forms.id;
          this.materials = res.data.details;
          this.bounds = res.data.bounds;
          this.bounds.forEach(item => {
            item.departmentId = item.departmentId || item.departmentID;
          });

          this.forms.companyId = this.forms.companyID;
          this.forms.departments = this.forms.departmentIds.split(',');

          //this.getFlowDraw();
        });
    }
  },
  created() {
    this.apiUrl = process.env.VUE_APP_BASEURL;

    this.$kaung.dictionary("stock", "factory").then((res) => { this.dict.factorys = res.filter(q => !!q.value); });
    this.$kaung.dictionary("stock", "metal").then((res) => { this.dict.metals = res; });
    this.$kaung.dictionary("stock", "material").then((res) => { this.dict.billTypes = res; })

    this.$kaung.companys().then((res) => {
      this.companys = res;
      this.forms.companyId = this.companys[0].id;
      this.companyChange();
    });
  },
  watch: {

  },
};
</script>
<style scoped>
.form-title {
  text-align: center;
  margin: 10px auto;
  padding-bottom: 20px;
  color: #000;
  font-size: 1.8em;
  font-weight: 400;
  border-bottom: 4px double #000;
  max-width: 410px;
  letter-spacing: 25px;
}
</style>